import { render, staticRenderFns } from "./DalinkPageFooter.vue?vue&type=template&id=16b206c9&scoped=true"
import script from "./DalinkPageFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./DalinkPageFooter.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DalinkPageFooter.vue?vue&type=style&index=0&id=16b206c9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b206c9",
  null
  
)

export default component.exports